import React from "react";
import "./style.css";

import PropTypes from "prop-types";

const Switcher = ({ options, selectedOption, handleChange, className }) => {
  const getTranslateXValue = () => {
    const selectedTabIndex = options.findIndex(option => option.idx === selectedOption)
    return (100 * (selectedTabIndex !== -1 ? selectedTabIndex : selectedOption));
  }

  return (
    <div className={className}>
      <div className="SwitcherContainer">
      {options.map((option) => (
        <div
          className={`SwitcherButton ${option.spacing ? "add-padding" : ""} ${selectedOption === option.idx ? "SwitcherActive" : ""}`}
          onClick={() => handleChange(option)}
          key={option.idx}
        >
          {option.label}
        </div>
      ))}
      <div
        className={"SwitcherToggle"}
        style={{
          width: `calc(100%/${options.length})`,
          transform: `translateX(${getTranslateXValue()}%)`,
        }}
      />
      </div>
    </div>
  )
}

Switcher.propTypes = {
  options: PropTypes.array,
  selectedOption: PropTypes.number,
  handleChange: PropTypes.func,
  className: PropTypes.string,
};


export default Switcher
